
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import * as echarts from 'echarts'
@Component({
  name: 'UserStatistics',
})
export default class extends Vue {
  @Prop() private userdata!: any
  @Watch('userdata')
  getData() {
    this.$nextTick(() => {
      this.initChart()
    })
  }
  initChart() {
    type EChartsOption = echarts.EChartsOption
    const chartDom = document.getElementById('usermain') as any
    const myChart = echarts.init(chartDom)

    const toNumbers = (arr: any): number[] => {
      if (!Array.isArray(arr)) return []
      return arr
        .map((v) => (typeof v === 'string' ? Number(v) : v))
        .filter((v) => typeof v === 'number' && isFinite(v))
    }

    const niceCeil = (v: number): number => {
      if (!isFinite(v) || v <= 0) return 0
      const exp = Math.pow(10, Math.floor(Math.log10(v)))
      const f = v / exp
      const nf = f <= 1 ? 1 : f <= 2 ? 2 : f <= 5 ? 5 : 10
      return nf * exp
    }

    const calcAxis = (values: number[]) => {
      if (!values.length) {
        return { min: 0, max: 5, interval: 1 }
      }
      const max0 = Math.max(...values)
      // 用户曲线通常更适合留更高的顶部空间，避免贴顶
      const paddedMax = max0 <= 0 ? 1 : max0 * 1.25
      const interval = Math.max(1, niceCeil(paddedMax / 6))
      const max = interval * 6
      return { min: 0, max, interval }
    }

    const values = [
      ...toNumbers(this.userdata && this.userdata.totalUserList),
      ...toNumbers(this.userdata && this.userdata.newUserList)
    ]
    const axis = calcAxis(values)

    var option: any
    option = {
      // legend: {
      //   itemHeight: 3, //图例高
      //   itemWidth: 12, //图例宽
      //   icon: 'rect', //图例
      //   show: true,
      //   top: 'bottom',
      //   data: ['用户总量', '新增用户'],
      // },
      tooltip: {
        trigger: 'axis',
        backgroundColor: '#fff', //背景颜色（此时为默认色）
        borderRadius: 2, //边框圆角
        textStyle: {
          color: '#333', //字体颜色
          fontSize: 12, //字体大小
          fontWeight: 300,
        },
      },
      grid: {
        top: '5%',
        left: '20',
        right: '50',
        bottom: '12%',
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        axisLabel: {
          //X轴字体颜色
          textStyle: {
            color: '#666',
            fontSize: '12px',
          },
        },
        axisLine: {
          //X轴线颜色
          lineStyle: {
            color: '#E5E4E4',
            width: 1, //x轴线的宽度
          },
        },
        data: this.userdata.dateList, //后端传来的动态数据
      },
      yAxis: [
        {
          type: 'value',
          min: axis.min,
          max: axis.max,
          interval: axis.interval,
          axisLabel: {
            textStyle: {
              color: '#666',
              fontSize: '12px',
            },
            // formatter: "{value} ml",//单位
          },
        }, //左侧值
      ],
      series: [
        {
          name: '用户总量',
          type: 'line',
          // stack: 'Total',
          smooth: false, //否平滑曲线
          showSymbol: false, //未显示鼠标上移的圆点
          symbolSize: 10,
          // symbol:"circle", //设置折线点定位实心点
          itemStyle: {
            normal: {
              color: '#4DA3FF',
              lineStyle: {
                color: '#4DA3FF',
              },
            },
            emphasis: {
              color: '#fff',
              borderWidth: 5,
              borderColor: '#4DA3FF',
            },
          },

          data: this.userdata.totalUserList,
        },
        {
          name: '新增用户',
          type: 'line',
          // stack: 'Total',
          smooth: false, //否平滑曲线
          showSymbol: false, //未显示鼠标上移的圆点
          symbolSize: 10, //圆点大小
          // symbol:"circle", //设置折线点定位实心点
          itemStyle: {
            normal: {
              color: '#FD7F7F',
              fontWeigth: 300,
              lineStyle: {
                color: '#FD7F7F',
              },
            },
            emphasis: {
              // 圆点颜色
              color: '#fff',
              borderWidth: 5,
              borderColor: '#FD7F7F',
            },
          },

          data: this.userdata.newUserList,
        },
      ],
    }
    option && myChart.setOption(option)
  }
}
